"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_1 = require("./styled");
var Switch = function (_a) {
    var activeMessage = _a.activeMessage, disableMessage = _a.disableMessage, activeDefault = _a.activeDefault, onChange = _a.onChange, onClick = _a.onClick, className = _a.className;
    var _b = react_1.useState(activeDefault), isActive = _b[0], setActive = _b[1];
    var text = react_1.useMemo(function () { return (isActive ? activeMessage : disableMessage); }, [
        isActive,
    ]);
    var toggle = react_1.useCallback(function () {
        var active = !isActive;
        setActive(active);
        if (onChange) {
            onChange({ active: active });
        }
        if (onClick) {
            onClick();
        }
    }, [isActive, onChange, onClick]);
    return (react_1.default.createElement(styled_1.StyledButton, { className: className, isActive: isActive, onClick: toggle }, text));
};
Switch.defaultProps = {
    activeDefault: true,
    activeMessage: 'Active',
    disableMessage: 'Disabled',
};
exports.default = Switch;
//# sourceMappingURL=index.js.map